import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { locationIdFormat } from "../ids";

export const RedoFulfillmentToteSchema = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
  team: zExt.objectId(),
  name: z.string(),
  barcode: z.string(),
  barcodeUrl: z.string().nullish(),
  pickSessionId: z.string().nullish(),
  toteGroupId: zExt.objectId().nullish(),
  locationId: locationIdFormat.schema.nullish(),
});

export type RedoFulfillmentTote = z.infer<typeof RedoFulfillmentToteSchema>;
